import {
  COMMON_PASSWORD_FRAGMENTS,
  PASSWORD_MIN_DISTINCT_CHARACTERS,
  PASSWORD_USERNAME_MIN_LENGTH,
} from './constants.ts';

// The password rules beyond length (which `passwordSchema` checks): the
// same function runs in the form, so a bad choice is flagged before it is
// sent, and on the Worker, so it is refused whatever the form did. Rules
// aim at the passwords that are guessed first, not at composition
// theatre: no digit or symbol quotas.

/** Why a password is refused, or null when it passes. */
export function passwordProblem(password: string, username: string): string | null {
  const lowered = password.toLowerCase();
  if (username.length >= PASSWORD_USERNAME_MIN_LENGTH && lowered.includes(username.toLowerCase())) {
    return 'Must not contain the username';
  }
  if (new Set(password).size < PASSWORD_MIN_DISTINCT_CHARACTERS) {
    return `Needs at least ${String(PASSWORD_MIN_DISTINCT_CHARACTERS)} different characters`;
  }
  if (/^\d+$/u.test(password)) {
    return 'Digits alone are too easy to guess';
  }
  const fragment = COMMON_PASSWORD_FRAGMENTS.find((word) => lowered.includes(word));
  if (fragment !== undefined) {
    return `Too common: contains "${fragment}"`;
  }
  return null;
}
